import api from "./api";


const add=(apiParams) =>{
	
	const apiPath = `/favorite/add`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("save favorite " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}
const remove=(apiParams) =>{
	
	const apiPath = `/favorite/remove`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("update favorite " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}

const inquireFavorites=async( filterType) =>{
	
	const apiPath = `/favorite/${filterType}`;
	console.log("inquireFavorites " + filterType);
	const response = api.get(apiPath);
	return response;

	
}

const inquireFavoriteArtists=async( ) =>{
	
	const apiPath = `/favorite/inquirefavoriteartists`;
	console.log("inquireFavoriteArtists " );
	const response = api.get(apiPath);
	return response;

	
}

const FavoriteService = {
	add,
	remove,	
	inquireFavorites,
	inquireFavoriteArtists
};

export default FavoriteService;
